/**
 * Maximum size for the main document upload paths (dashboard/navbar drop zone,
 * Document Center upload modal). Mirrors MAX_DOCUMENT_UPLOAD_SIZE_KB on the
 * backend and the nginx/PHP body limits on the server; keep them in sync.
 */
export const MAX_DOCUMENT_UPLOAD_SIZE_BYTES = 50 * 1024 * 1024;

export interface FilesBySizeLimit {
    accepted: File[];
    rejected: File[];
}

export function splitFilesBySizeLimit(files: File[] | undefined, maxBytes: number = MAX_DOCUMENT_UPLOAD_SIZE_BYTES): FilesBySizeLimit {
    const result: FilesBySizeLimit = { accepted: [], rejected: [] };
    for (const file of files ?? []) {
        (file.size > maxBytes ? result.rejected : result.accepted).push(file);
    }
    return result;
}
